module.exports = __webpack_public_path__ + "img/slide2-min.bc87fa57.png";